import React from 'react'

import ProvincialResult from '../../../models/ProvincialResult'
import Party from '../../../models/Party'
import Utilities from '../../../utils/Utilities'
import { PartyResultCell } from '../Cells/PartyResultCell'

interface IProps {
  provincialResult: ProvincialResult | null
}

class ProvincialResultTableRow extends React.Component<IProps> {
  public render(): JSX.Element {
    const { provincialResult } = this.props

    if (!provincialResult) {
      return <tr />
    }

    const seatCells = Party.allPartiesArray().map(
      (party): JSX.Element => (
        <PartyResultCell
          className="pt-3 SeatCell"
          key={party.key}
          party={party}
          areaResult={provincialResult}
          accessor={(result): number => result.seatCount}
        />
      )
    )

    const voteCells = Party.allPartiesArray().map(
      (party): JSX.Element => (
        <PartyResultCell
          key={party.key}
          party={party}
          areaResult={provincialResult}
          accessor={(result): number => result.votePercent}
          formatter={Utilities.formatPercent}
        />
      )
    )

    return (
      <React.Fragment>
        <tr className="BorderTop">
          <td
            className="align-middle text-right pr-3 font-weight-bold"
            rowSpan={2}
          >
            <span className="d-none d-sm-inline">
              {provincialResult.province.name()}
              <br />
              <small>{provincialResult.totalSeatCount} seats</small>
            </span>
            <abbr
              className="d-sm-none"
              title={provincialResult.province.name()}
            >
              {provincialResult.province.shortName}
            </abbr>
          </td>
          <td className="pt-3">Seats</td>
          {seatCells}
        </tr>
        <tr>
          <td className="pb-3">Vote %</td>
          {voteCells}
        </tr>
      </React.Fragment>
    )
  }
}

export default ProvincialResultTableRow
